import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "bi-tmpl-detail__right__cmpt__title",
  style: {"margin":"0 16px 0 0"}
}, " 是否在BI中展示附件 ", -1)
const _hoisted_5 = {
  class: "xrk-card",
  style: {"width":"420px","height":"660px"}
}
const _hoisted_6 = { style: {
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            padding: '0 20px',
            top: '0',
            left: '0'
          } }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"transform-origin":"0 0","padding":"18px 24px","border":"2px dashed rgb(167, 167, 167)","transform":"translateY(-8px) scale(0.5)","width":"750px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, " 相关性热图是一种二维可视化图表，用来分析不同变量之间的相关性和变化趋势。每个数据点的颜色表示该变量之间的相关性强度，常用于探索数据集中的模式和关系。相比于简单的散点图，相关性热图能够显示更加复杂的数据结构，为数据分析提供更全面的视角和更深入的理解。 ")
], -1)
const _hoisted_8 = { style: {"margin":"0 auto","width":"350px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"transform-origin":"0 0","padding":"18px 24px","border":"2px dashed rgb(167, 167, 167)","transform":"scale(0.5)","width":"750px"} }, " 斯皮尔曼相关系数的数值代表两个变量之间的相关强度和方向。范围是从-1到+1。如果相关系数为正，表示当一个变量增加时，另一个变量也倾向于增加。如果相关系数为负，表示当一个变量增加时，另一个变量倾向于减少。相关系数的绝对值越大，表示两个变量之间的相关性越强。当相关系数的绝对值接近1时，表示两个变量之间存在完全的单调关系；当相关系数的绝对值接近0时，表示两个变量之间几乎没有任何相关性。 ", -1)
const _hoisted_10 = {
  class: "xrk-card",
  style: {"width":"420px","height":"660px"}
}
const _hoisted_11 = { style: {
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            top: '0',
            left: '0',
            padding: '10px 20px'
          } }
const _hoisted_12 = { style: {"margin":"0 auto","width":"350px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"transform-origin":"0 0","padding":"18px 24px","border":"2px dashed rgb(167, 167, 167)","transform":"scale(0.5)","width":"750px"} }, /*#__PURE__*/_toDisplayString(`如果 P 值很小（通常认为小于 0.05 或 0.01），这意味着两个变量之间的相关性是显著的，即它们之间存在一定的关联。这种关联可能是正相关或负相关，具体取决于斯皮尔曼相关系数的值。如果 P 值大于 0.05，这意味着两个变量之间的相关性不显著，即它们之间没有明显的关联。这可能是因为数据量不足、样本偏差或其他原因导致的结果。`), -1)
const _hoisted_14 = {
  class: "xrk-card",
  style: {"width":"420px","height":"660px"}
}
const _hoisted_15 = { style: {
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            top: '0',
            left: '0',
            padding: '18px 20px'
          } }
const _hoisted_16 = { style: {"margin":"0 auto","width":"380px"} }

import { ref } from 'vue';
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import {
  PcModuleHeatmapOnCartesian_1,
  PcModuleHeatmapOnCartesian_2,
  PcModuleHeatmapOnCartesian_3
} from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-heatmap-on-cartesian';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-16',
  setup(__props) {

const { curItem, onChange, titleCmpt, pageNoCmpt, subTitleCmpt, state } =
  useDetailCmpt({});

const colorList = ref(
  state.value.menuValue.get('101').value['101_1'].value.split(',')
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(BaseRadio), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onChange)('1'))),
          value: "1",
          "model-value": _unref(curItem).value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 是 ")
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createVNode(_unref(BaseRadio), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onChange)('0'))),
          value: "0",
          "model-value": _unref(curItem).value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 否 ")
          ]),
          _: 1
        }, 8, ["model-value"])
      ])
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_unref(titleCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleCmpt)), _mergeProps({
                  key: 0,
                  style: {"width":"1200px","transform":"scale(0.33)","transform-origin":"0 center"}
                }, {
              innerText: '相关性热图',
              enInnerText: 'correlation heatmap & correlation clustermap'
            }), null, 16))
              : _createCommentVNode("", true),
            _hoisted_7,
            (_unref(subTitleCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(subTitleCmpt)), _mergeProps({
                  key: 1,
                  class: "subTitleCmpt-16",
                  style: {"height":"32px"}
                }, {
              innerText: '热图-系数（r）'
            }), null, 16))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(PcModuleHeatmapOnCartesian_1), { "color-list": colorList.value }, null, 8, ["color-list"])
            ]),
            _hoisted_9,
            (_unref(pageNoCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                  key: 2,
                  style: {"width":"80px","height":"40px"}
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_unref(subTitleCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(subTitleCmpt)), _mergeProps({
                  key: 0,
                  style: {"height":"32px"}
                }, {
              innerText: '热图-P值'
            }), null, 16))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(PcModuleHeatmapOnCartesian_2), { "color-list": colorList.value }, null, 8, ["color-list"])
            ]),
            _hoisted_13,
            (_unref(pageNoCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                  key: 1,
                  style: {"width":"80px","height":"40px"},
                  pageNo: "02"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_unref(subTitleCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(subTitleCmpt)), _mergeProps({
                  key: 0,
                  style: {"height":"32px"}
                }, {
              innerText: '附件'
            }), null, 16))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(PcModuleHeatmapOnCartesian_3))
            ]),
            (_unref(pageNoCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                  key: 1,
                  style: {"width":"80px","height":"40px"},
                  pageNo: "03"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})